import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_2 = { class: "control-label col-sm-6" }
const _hoisted_3 = { class: "col-sm" }
const _hoisted_4 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_5 = { class: "control-label col-sm-6" }
const _hoisted_6 = { class: "col-sm" }
const _hoisted_7 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_8 = { class: "control-label col-sm-6" }
const _hoisted_9 = { class: "col-sm" }
const _hoisted_10 = {
  key: 1,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_11 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_12 = { class: "col-sm" }
const _hoisted_13 = {
  key: 2,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_14 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_15 = { class: "col-sm crm:text-right" }
const _hoisted_16 = {
  key: 3,
  class: "row crm:items-center crm:mb-2"
}
const _hoisted_17 = { class: "control-label col-sm-6 crm:relative" }
const _hoisted_18 = { class: "col-sm crm:text-right" }
const _hoisted_19 = {
  key: 4,
  class: "crm:flex crm:items-center crm:justify-end"
}
const _hoisted_20 = ["disabled"]

import { ref, inject, watch, onBeforeMount } from 'vue';
import { usePreventivo } from '../../composable/usePreventivo';

export default {
  __name: 'CalcoloEquoCompenso',
  props: {
  inputRiferimentoCalcolo: [String, Array],
  dynamicInput: {
    type: Boolean,
    default: false
  },
  validazione: {
    type: [Object],
    default: {}
  },
  helper: {
    type: [Object, String],
    default: {}
  },
  readonly: {
    type: Boolean,
    default: false
  },
  filterOptionsD:{
    type:Boolean,
    default:false
  }
},
  setup(__props) {

const {
  formatterSomma,
  formatterValore,
  formatterValoreAliquota
} = usePreventivo();
const $AxiosClient = inject('$AxiosClient');
const props = __props;
const dati_distretto = inject('datiDistretto');
const valore_percentuale_distretto = ref();
valore_percentuale_distretto.value = dati_distretto.value.distretto ? formatterSomma(dati_distretto.value.distretto.coefficiente_spese_generali_equo_compenso) : formatterSomma(15);
props.validazione.coefficiente_spese_generali.value = valore_percentuale_distretto.value;
const coefficienteCalcolato = ref('');
const valorePrecedenteInputDiRiferimento = ref('');
const valorePrecedenteTipologiaTabellaCalcolo = ref('');
const valorePrecedenteCoefficiente = ref('');
const valoreSommato = ref(false);
const arrayDefaultOptions = ref([
  { name: 'Tabella A, Atti Immobiliari', value: 'immobiliari' },
  { name: 'Tabella B, Atti Mobiliari', value: 'mobiliari' },
  { name: 'Tabella C, Atti Societari', value: 'societari' },
  { name: 'Tabella D, Altri atti', value: 'altri_atti' },
  { name: 'Tabella D, Atti procedimentalizzati', value: 'atti_procedimentalizzati' },
]);
function aggiornaValidazioneCampiEquoCompenso(event) {
  if (event.target.checked === true) {
    props.validazione.tipologia_tabella_calcolo.required = true;
    props.validazione.coefficiente_spese_generali.required = true;
    props.validazione.valore_equo_compenso_calcolato.required = true;
    props.validazione.valore_equo_compenso_calcolato_spese_generali.required = true;
  } else {
    props.validazione.valore_equo_compenso.value = '';
    props.validazione.tipologia_tabella_calcolo.required = false;
    props.validazione.coefficiente_spese_generali.required = false;
    props.validazione.tipologia_tabella_calcolo.value = '';
    props.validazione.coefficiente_spese_generali.value = '15';
    props.validazione.valore_equo_compenso_calcolato.required = false;
    props.validazione.valore_equo_compenso_calcolato_spese_generali.required = false;
    props.validazione.valore_equo_compenso_calcolato.value = '';
    props.validazione.valore_equo_compenso_calcolato_spese_generali.value = '';
    props.validazione.equo_compenso_indicato.value = '';
  }
}
watch(props.validazione, (newValue) => {
  // Controllo se l'utente va a modificare i dati per il calcolo dell'equo compenso e svuoto i valori calcolati
  let valore = 0;
  let valoreInputDiRiferimento = 0;
  if (typeof props.inputRiferimentoCalcolo != 'string' && props.inputRiferimentoCalcolo.length > 1 && props.dynamicInput === false) {
    // Se l'input di riferimento da controllare è più di uno, controlla che il tipo di dato sia un array e somma i valori
    props.inputRiferimentoCalcolo.forEach((item) => {
      let valore_input = formatterSomma(typeof newValue[item].value == 'string' ? newValue[item].value.replace('€', '') : newValue[item].value);
      valore = valore + valore_input;
    })
    valoreSommato.value      = valore > 0;
    valoreInputDiRiferimento = valore;
  } else if (typeof props.inputRiferimentoCalcolo == 'string' && props.dynamicInput === true) {
    // Se l'input di riferimento da controllare viene passato come stringa ma la prop dynamic input è true,
    // deve recuperare tutti gli input dinamici creati (presenti nel value dell'elemento princiaple) e li somma
    Object.keys(newValue[props.inputRiferimentoCalcolo].value).forEach((item) => {
      let valore_input = formatterSomma(typeof newValue[props.inputRiferimentoCalcolo].value[item].value == 'string' ? newValue[props.inputRiferimentoCalcolo].value[item].value.replace('€', '') : newValue[props.inputRiferimentoCalcolo].value[item].value);
      valore = valore + valore_input;
    })
    valoreSommato.value      = valore > 0;
    valoreInputDiRiferimento = valore;
  } else {
    if(props.filterOptionsD){
      valoreInputDiRiferimento = 0;
    } else {
      // Situazione statica, con un input di riferimento
      valoreInputDiRiferimento = formatterSomma(typeof newValue[props.inputRiferimentoCalcolo].value == 'string' ? newValue[props.inputRiferimentoCalcolo].value.replace('€', '') : newValue[props.inputRiferimentoCalcolo].value);
    }
    valoreSommato.value = true;
  }

  props.validazione.equo_compenso_indicato.required = newValue.tipologia_tabella_calcolo.value === 'altri_atti' ||
    newValue.tipologia_tabella_calcolo.value === 'atti_procedimentalizzati';

  if(newValue.equo_compenso_indicato.value !== 0 &&
    (newValue.tipologia_tabella_calcolo.value === 'altri_atti' || newValue.tipologia_tabella_calcolo.value === 'atti_procedimentalizzati')){
    valoreInputDiRiferimento = newValue.equo_compenso_indicato.value;
  }


  if (valorePrecedenteCoefficiente.value !== '' && valorePrecedenteCoefficiente.value !== newValue.coefficiente_spese_generali.value) {
    props.validazione.valore_equo_compenso_calcolato.value = '';
    props.validazione.valore_equo_compenso_calcolato_spese_generali.value = '';
  }

  if (valorePrecedenteTipologiaTabellaCalcolo.value !== '' && valorePrecedenteTipologiaTabellaCalcolo.value !== newValue.tipologia_tabella_calcolo.value) {
    props.validazione.valore_equo_compenso_calcolato.value = '';
    props.validazione.valore_equo_compenso_calcolato_spese_generali.value = '';
  }

  if (valorePrecedenteInputDiRiferimento.value !== '' && valorePrecedenteInputDiRiferimento.value !== valoreInputDiRiferimento) {
    props.validazione.valore_equo_compenso_calcolato.value = '';
    props.validazione.valore_equo_compenso_calcolato_spese_generali.value = '';
  }

  props.validazione.valore_equo_compenso.value = valoreInputDiRiferimento;
});
async function calcolaEquoCompenso() {
  // Aggiungiamo un calcolo per il Preventivo 1.6.10 dove viene richiesto un ricalcolo prima di inviare i dati
  let calcoloAggiornato = false;
  let valoreAggiornato = 0;

  if (props.validazione.tipo_preventivo.value === 'immobiliare/donazioni_risoluzioni/donazioni_beni_immobili') {
    if (props.validazione.tipologia.value === 'valore_suggerito_da_rendita_catastale') {
      calcoloAggiornato = true;
      let valore_prima_casa = (formatterSomma(props.validazione.rendita_catastale_prima_casa.value) * 115.50);
      let valore_altri_beni = 0;
      let valore_tipologia_immobile = 0;
      if (formatterSomma(props.validazione.rendita_catastale_seconda_casa.value) > 0) {
        switch (props.validazione.tipologia_immobile.value) {
          case 'cat_a_c':
            valore_tipologia_immobile = 126
            break;
          case 'cat_b':
            valore_tipologia_immobile = 147
            break;
          case 'cat_d_a10':
            valore_tipologia_immobile = 63
            break;
          case 'cat_e_c1':
            valore_tipologia_immobile = 42.84
            break;
          case 'cat_t':
            valore_tipologia_immobile = 112.50
            break;
        }
        valore_altri_beni = formatterSomma(props.validazione.rendita_catastale_seconda_casa.value) * valore_tipologia_immobile
      }
      valoreAggiornato = valore_prima_casa + valore_altri_beni
    }
  }

  valorePrecedenteInputDiRiferimento.value = props.validazione.valore_equo_compenso.value;
  valorePrecedenteTipologiaTabellaCalcolo.value = props.validazione.tipologia_tabella_calcolo.value;
  valorePrecedenteCoefficiente.value = props.validazione.coefficiente_spese_generali.value
  let valoreEquoCompensoCalcolato = await $AxiosClient.post('Preventivi', 'calcolaEquoCompenso', {
    'valore_equo_compenso': calcoloAggiornato ? valoreAggiornato : props.validazione.valore_equo_compenso.value,
    'tipologia_tabella_calcolo': props.validazione.tipologia_tabella_calcolo.value,
    'coefficiente_spese_generali': props.validazione.coefficiente_spese_generali.value
  });

  if (valoreEquoCompensoCalcolato.esito === 'ok') {
    props.validazione.valore_equo_compenso_calcolato.value = valoreEquoCompensoCalcolato.equo_compenso;
    props.validazione.valore_equo_compenso_calcolato_spese_generali.value = valoreEquoCompensoCalcolato.equo_compenso_comprensivo_di_spese_generali;
    coefficienteCalcolato.value = valoreEquoCompensoCalcolato.equo_compenso_aliquota != null ? formatterValoreAliquota(valoreEquoCompensoCalcolato.equo_compenso_aliquota) : ''
  }
}
onBeforeMount(() => {
  // preventivo 1.5.20/1.5.30 aggiungere tabelle Surroghe alla select
  if (props.validazione.tipo_preventivo.value === 'immobiliare/mutuo_surroga/mutuo_surroga' ||
    props.validazione.tipo_preventivo.value === 'immobiliare/mutuo_surroga/quietanza_per_surrogazione') {
    arrayDefaultOptions.value.push(
      { name: 'Tabella Surroga Convenzionata', value: 'surroga_convenzionata' },
      { name: 'Tabella Quietanza di Surroga Convenzionata', value: 'quietanza_di_surroga_convenzionata' })
  }
  if(props.filterOptionsD){
    arrayDefaultOptions.value = [];
    arrayDefaultOptions.value.push(
      { name: 'Tabella D, Altri atti', value: 'altri_atti' },
      { name: 'Tabella D, Atti procedimentalizzati', value: 'atti_procedimentalizzati' })
  }
})

return (_ctx, _cache) => {
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "crm:my-0 crm:bg-secondary" }, null, -1 /* CACHED */)),
    _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "crm:font-bold! crm:uppercase crm:mb-3! crm:mt-4!" }, "Calcolo Equo Compenso", -1 /* CACHED */)),
    _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "crm:my-0 crm:bg-secondary crm:mb-4!" }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_2, [
        _createTextVNode(_toDisplayString(__props.validazione.abilitare_equo_compenso.label), 1 /* TEXT */)
      ])), [
        [_directive_fallcohelper, __props.helper.calcolo.abilitare_equo_compenso.ref]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_input_checkbox, {
          name: "abilitare_equo_compenso",
          label: "Si, abilita",
          onChange: _cache[0] || (_cache[0] = $event => (aggiornaValidazioneCampiEquoCompenso($event))),
          class: _normalizeClass(__props.readonly ? 'crm:opacity-20  crm:pointer-events-none' : ''),
          "validate-to": __props.validazione.abilitare_equo_compenso,
          "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((__props.validazione.abilitare_equo_compenso) = $event))
        }, null, 8 /* PROPS */, ["class", "validate-to"])
      ])
    ]),
    (__props.validazione.abilitare_equo_compenso.value === '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_5, [
            _createTextVNode(_toDisplayString(__props.validazione.tipologia_tabella_calcolo.label), 1 /* TEXT */)
          ])), [
            [_directive_fallcohelper, __props.helper.calcolo.tipologia_tabella_calcolo.ref]
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_base_select, {
              name: "tipologia_tabella_calcolo",
              options: arrayDefaultOptions.value,
              isSelected: __props.validazione.tipologia_tabella_calcolo.value !== '',
              state: __props.readonly === true ? 'disable' : '',
              validateTo: __props.validazione.tipologia_tabella_calcolo,
              "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((__props.validazione.tipologia_tabella_calcolo) = $event))
            }, null, 8 /* PROPS */, ["options", "isSelected", "state", "validateTo"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_8, [
        _createTextVNode(_toDisplayString(__props.validazione.equo_compenso_indicato.label), 1 /* TEXT */)
      ])), [
        [_directive_fallcohelper, __props.helper.calcolo.equo_compenso_indicato.ref]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_base_input_text, {
          id: "equo_compenso_indicato",
          name: "equo_compenso_indicato",
          class: "placeholder-right crm:text-right",
          placeholder: "Indicare il valore dell'equo compenso",
          disabled: __props.readonly,
          "validate-to": __props.validazione.equo_compenso_indicato,
          "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((__props.validazione.equo_compenso_indicato) = $event))
        }, null, 8 /* PROPS */, ["disabled", "validate-to"])
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, __props.validazione.tipologia_tabella_calcolo.value === 'atti_procedimentalizzati' || __props.validazione.tipologia_tabella_calcolo.value === 'altri_atti']
    ]),
    (__props.validazione.abilitare_equo_compenso.value === '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_11, [
            _createTextVNode(_toDisplayString(__props.validazione.coefficiente_spese_generali.label), 1 /* TEXT */)
          ])), [
            [_directive_fallcohelper, __props.helper.calcolo.coefficiente_spese_generali.ref]
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_base_input_text, {
              id: "coefficiente_spese_generali ",
              name: "coefficiente_spese_generali ",
              class: "placeholder-right crm:text-right",
              placeholder: "Indicare la percentuale",
              disabled: __props.readonly,
              "validate-to": __props.validazione.coefficiente_spese_generali,
              "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((__props.validazione.coefficiente_spese_generali) = $event))
            }, null, 8 /* PROPS */, ["disabled", "validate-to"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (__props.validazione.valore_equo_compenso_calcolato.value !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, "Equo compenso " + _toDisplayString(coefficienteCalcolato.value !== '' ? `(Coeff.
      ${coefficienteCalcolato.value}%)` : ''), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", null, _toDisplayString(_unref(formatterValore)(__props.validazione.valore_equo_compenso_calcolato.value) + ' €'), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (__props.validazione['valore_equo_compenso_calcolato_spese_generali'].value !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, "Equo compenso " + _toDisplayString(coefficienteCalcolato.value !== '' ? `(Coeff.
      ${coefficienteCalcolato.value}%)` : '') + " compreso di spese generali al " + _toDisplayString(props.validazione.coefficiente_spese_generali.value) + "%", 1 /* TEXT */),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", null, _toDisplayString(_unref(formatterValore)(__props.validazione.valore_equo_compenso_calcolato_spese_generali.value) + ' €'), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (__props.validazione.abilitare_equo_compenso.value === '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "btn btn-default crm:my-4!",
            type: "reset",
            ref: "resetBtn",
            disabled: !valoreSommato.value,
            onClick: _cache[5] || (_cache[5] = _withModifiers($event => (calcolaEquoCompenso()), ["prevent"]))
          }, " Calcola Equo Compenso ", 8 /* PROPS */, _hoisted_20)
        ]))
      : _createCommentVNode("v-if", true),
    _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "crm:my-0 crm:bg-secondary crm:mb-4!" }, null, -1 /* CACHED */))
  ], 64 /* STABLE_FRAGMENT */))
}
}

}